<template>
  <div>
    <div class="withdrawalConfirm">
      <div class="withdrawalConfirm__body">
        <h2>退会される場合の注意事項</h2>
        <p class="withdrawalConfirm__notice">
          一度退会すると、保有ポイントや登録データがすべて削除され、それらの情報を復活することはできません。
        </p>
        <Btn
          :label="'戻る'"
          :color="'borderRed'"
          class="back"
          @click.native="goBackToEcSite"
        />
        <Btn
          :label="'承諾の上、退会する'"
          :color="'red'"
          class="withdraw"
          @click.native="isOpenConfirm = true"
        />
        <p
          v-if="validation"
          class="err"
        >
          {{ validation }}
        </p>
      </div>
    </div>

    <!--最終確認モーダル-->
    <ModalConfirm
      v-if="isOpenConfirm"
      :name-action="'退会する'"
      :message="'本当に退会しますか？'"
      @cancel="isOpenConfirm = false"
      @action="submit"
    />
  </div>
</template>

<script>
import error from '@/mixin/error.mixin'
import redirect from '@/mixin/redirect.mixin'
import store from '@/store'
import Btn from '@/components/parts/Btn'
import ModalConfirm from '@/components/ModalConfirm'

export default {
  name: 'WithdrawalStep01Confirm',

  mixins: [
    // APIエラーメッセージ
    error,
    // リダイレクト ※ GETパラメータ (redirecturl, backurl)
    redirect
  ],

  components: {
    Btn,
    ModalConfirm
  },

  data () {
    return {
      validation: '',
      isOpenConfirm: false
    }
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    submit () {
      this.isOpenConfirm = false
      store.commit('loadingAction', true)
      store.dispatch('auth/withdrawal').then(() => {
        this.goToEcSite()
      }).catch((err) => {
        store.commit('loadingAction', false)
        this.validation = this.getValidateErrorMessage(err)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
  .withdrawalConfirm {
    min-height: calc(100vh - 50px);
    &__body {
      margin: 75px 15px 30px;
      text-align: center;
      & .err {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
        color: #ff0000;
      }

      h2 {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.6;
        text-align: center;
        margin-bottom: 20px;
      }
    }
    &__notice {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.6;
      text-align: center;
      color: #ff0000;
      margin-bottom: 40px;
    }
    & .back {
      display: block;
      margin: 20px auto 0;
      max-width: 350px;
    }
    & .withdraw {
      margin-top: 80px;
      max-width: 220px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/withdrawal/Step01Confirm.vue